module.exports = __webpack_public_path__ + "img/cart-white.02f4417d.svg";